import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, Subject } from 'rxjs';

import { CmsService } from '../../../../core/services/cms.service';
import { Destroyed } from '../../../../shared/decorators/destroyed';
import { Article } from '../../../../shared/model/article.model';

@Component({
  selector: 'raf-article-dialog',
  templateUrl: './article-dialog.component.html',
  styleUrls: ['./article-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArticleDialogComponent implements OnInit {
  @Destroyed
  destroyed$!: Subject<void>;

  article$: BehaviorSubject<Article | null> = new BehaviorSubject<Article | null>(null);
  loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor(
    private dialogRef: MatDialogRef<ArticleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private articleId: string,
    private cmsService: CmsService
  ) {}

  ngOnInit(): void {
    if (this.articleId) {
      this.loadArticle(this.articleId);
    }
  }

  loadArticle(articleId: string): void {
    this.loading$.next(true);
    this.cmsService
      .getArticle(articleId)
      .subscribe((res) => {
        this.article$.next(res);
      })
      .add(() => this.loading$.next(false));
  }

  close() {
    this.dialogRef.close();
  }
}
